import(/* webpackMode: "eager", webpackExports: ["AuthGuard"] */ "/root/Coffee/components/AuthGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Coffee/components/ErrorReporterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeInitializer"] */ "/root/Coffee/components/ThemeInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/root/Coffee/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardProvider"] */ "/root/Coffee/contexts/DashboardContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/root/Coffee/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/Coffee/styles/globals.css");
